import { Inter as FontSans } from "next/font/google"

export const fontSans = FontSans({
  subsets: ["latin"],
  variable: "--font-sans",
})

export const CookieList = [
  {
    key: "session",
    defaultValue: true,
    required: true,
    title: "Session Cookie",
    description:
      "Unser Webserver setzt automatisiert Sitzungsdaten, um einzelne Nutzer unterscheiden zu können. Diese Daten werden nicht außerhalb der ordnungsgemäßen Funktionsweise des Servers weiterverwendet.",
  },
  {
    key: "_umami",
    defaultValue: true,
    required: true,
    title: "Umami",
    description:
      "Unser Webserver setzt automatisiert Sitzungsdaten, um Fehler in der Funktionalität zu erkennen. Diese Daten werden von uns genutzt, um unsere Servicequalität zu verbessern.",
  },
  {
    key: "_ga",
    defaultValue: false,
    required: false,
    title: "Google Analytics",
    description:
      "Wir verwenden Google Analytics um unseren Service weiterzuentwickeln.",
  },
  {
    key: "_gid",
    defaultValue: false,
    required: false,
    title: "Google Identifier",
    description:
      "Wir verwenden Google Analytics um unseren Service weiterzuentwickeln.",
  },
  {
    key: "_gat",
    defaultValue: false,
    required: false,
    title: "Google Performance",
    description:
      "Wir verwenden Google Analytics um unseren Service weiterzuentwickeln.",
  },
  {
    key: "AMP_TOKEN",
    defaultValue: false,
    required: false,
    title: "Google AMP",
    description:
      "Wir verwenden Google Analytics um unseren Service weiterzuentwickeln.",
  },
  {
    key: "_gac_prop",
    defaultValue: false,
    required: false,
    title: "Google Analytics Property",
    description:
      "Wir verwenden Google Analytics um unseren Service weiterzuentwickeln.",
  },
  {
    key: "__gcl_au",
    defaultValue: false,
    required: false,
    title: "Google Analytics User",
    description:
      "Wir verwenden Google Analytics um unseren Service weiterzuentwickeln.",
  },
  {
    key: "sentryReplaySession",
    defaultValue: false,
    required: true,
    title: "Glitch Tip Session",
    description:
      "Wir verwenden Glitch um unseren Service weiterzuentwickeln.",
  },
  {
    key: "__stripe_mid",
    defaultValue: false,
    required: true,
    title: "Stripe Session",
    description:
      "Wir verwenden Stripe um Zahlungen zu verarbeiten.",
  },
  {
    key: "clarity",
    defaultValue: false,
    required: false,
    title: "Clarity",
    description: "Wir verwenden Microsoft Clarity um unseren Service weiterzuentwickeln.",
  },
  {
    key: "meta",
    defaultValue: false,
    required: false,
    title: "Meta Pixel",
    description: "Wir verwenden Meta Pixel, um das Nutzerverhalten auf unserer Webseite zu analysieren und unsere Marketingmaßnahmen zu optimieren.",
  },
]
